<p class="text-subtitle text-center text-top">
  @if (reason === 'new_password_required') {
    Je wachtwoord voldoet helaas niet meer aan de laatste veiligheidsstandaarden, daarom vragen we je om een nieuw
    wachtwoord in te stellen.
  } @else {
    Op deze pagina kun je een nieuw wachtwoord instellen. Volg onze richtlijnen zodat je account goed beschermd is.
  }
</p>

<div class="container" [formGroup]="form">
  <app-input type="password" formControlName="password">Wachtwoord</app-input>
  <app-input type="password" formControlName="confirm_password">Wachtwoord herhalen</app-input>

  <div id="invalid">
    @if (form.getError('invalid')) {
      <div class="text-primary text-center">Ongeldige inloggegevens</div>
    }
  </div>

  <app-password-validation-display [form]="form"/>

  <div class="login-box">
    <app-button (click)="submit()" [block]="true" onkeydown="" [disabled]="form.invalid">
      Wachtwoord wijzigen
    </app-button>
    <a class="link hoverable text-subtitle text-center link-text-only" routerLink="/login">Terug naar login</a>
  </div>
</div>
